<template>
  <div>
    <v-card class="pa-2">
      <v-icon
        medium
        left
      >
        assignment_ind
      </v-icon>
      <span class="title font-weight-light">Informações Instrutor</span>
      <v-layout wrap>
        <v-flex
          xs12
          sm12
          md4
        >
          <v-img
            aspect-ratio="1.9"
            contain
            :src="require('./../../assets/icon_user.png')"
            max-height="400"
          />
        </v-flex>
        <v-flex
          xs12
          sm12
          md8
        >
          <v-card-text>
            <v-layout
              column
              wrap
              class="pl-2"
            >
              <v-flex
                xs12
                sm12
                md12
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md8
                    pa-1
                  >
                    <v-text-field
                      v-model="aluno.nome"
                      label="Nome"
                      placeholder="Informe seu nome aqui"
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md4
                    pa-1
                  >
                    <v-text-field
                      v-model="aluno.cpf"
                      label="CPF"
                      placeholder="000.000.000-00"
                      :mask="mask_cpf"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      mask_cpf: '###.###.###-##',
      mask_renach: '###.###.###',
      terminado: true,
      alerts: {
        show: true,
        items: [],
      },
      dialog: {
        title: 'Baixando informações',
        message: 'Aguarde carregando...',
      },
      aluno: { nome: 'Joao da Gloria', cpf: '11542765978'},
      token: null,
    };
  },
  mounted() {
  },
  methods: {
    mountAlerts(classType, msg) {
      this.alerts.items.push({ classType, msg });
    },
  },
};
</script>
